import "../styles/headers.css";

export function PageHeader(props) {
  return (
    <div className="header-container" align="left">
      <h1 className="header">{props.header}</h1>
      <p className="subheader">{props.subheader}</p>
    </div>
  );
}